import React, { useState, useEffect, useContext } from 'react';
import { Apirequests } from '../../utils/ApiRequests';
import { AuthContext } from '../../contexts/AuthContext';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import Replies from './Replies';
import { SuccessTost } from '../../utils/ToastHelper';
import { Edit, Trash } from 'lucide-react';
import { comment } from 'postcss';

// Example data for comments (replace with your API data)
const exampleComments = [
    {
        _id: '1',
        userId: { name: 'John Doe', email: 'john@example.com' },
        content: 'This is a great lesson!',
        status: 'Approved',
        createdAt: '2026-04-21T10:12:38.047Z',
        replies: [
            {
                userId: { name: 'Jane Smith', email: 'jane@example.com' },
                content: 'I agree!',
                createdAt: '2026-04-21T10:15:00.047Z',
                status: 'Approved',
            },
        ],
    },
    {
        _id: '2',
        userId: { name: 'Alice Green', email: 'alice@example.com' },
        content: 'Very informative content.',
        status: 'Not Approved',
        createdAt: '2026-04-22T12:12:38.047Z',
        replies: [],
    },
];

const CommentTable = ({ lessonId }) => {
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(false);
    const { user } = useContext(AuthContext);
    const [viewreplies, setViewReplies] = useState({ state: false, replies: [], commentId: "" });
    const [approveLoading, setApproveLoading] = useState(false);


    // Fetch data (using example data for now)
    console.log(lessonId, 'lessonId')

    const fetchComments = async (lessonId) => {
        setLoading(true);
        try {
            const res = await Apirequests(`lesson/get-comments?lessonId=${lessonId}&userId=${user._id}`, "GET", {}, {});
            if (res?.success) {
                setComments(res.data);
            } else {
                console.error('Failed to fetch comments');
            }
        } catch (error) {
            console.error('Error fetching comments:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchComments(lessonId);
    }, [lessonId]);


    const approveCommentOrReply = async (commentId, replyId) => {
        setApproveLoading(true);
        try {
            const res = await Apirequests(`lesson/approve`, "PATCH", {
                userId: user._id,
                commentId,
                replyId
            }, {});
            if (res?.success) {
                fetchComments(lessonId);
                await SuccessTost("Comment/Reply approved successfully");
            } else {
                console.error('Failed to approve comment/reply');
            }
        } catch (error) {
            console.error('Error approving comment/reply:', error);
        }
        setApproveLoading(false);
    };

    const deleteCommentOrReply = async (commentId, replyId) => {
        try {
            const res = await Apirequests(`lesson/delete-comment`, "DELETE", {
                userId: user._id,
                commentId,
                replyId
            }, {});
            if (res?.success) {
                fetchComments(lessonId);
                await SuccessTost("Comment/Reply deleted successfully");
            } else {
                console.error('Failed to delete comment/reply');
            }
        } catch (error) {
            console.error('Error deleting comment/reply:', error);
        }
    };

    return (
        <div className="p-6 max-w-7xl mx-auto bg-white rounded-lg">
            <h2 className="text-2xl font-semibold text-center text-purple-700 mb-6">
                Comments
            </h2>
            {
                loading ?
                    <p>Please Wait......</p> :
                    comments?.length === 0 ? (
                        <p className="text-center text-gray-500">No comments available.</p>
                    ) :
                        <table className="min-w-full table-auto">
                            <thead>
                                <tr className="bg-purple-600 text-white">
                                    <th className="px-4 py-2 text-left">Actions</th>
                                    <th className="px-4 py-2 text-left">User</th>
                                    <th className="px-4 py-2 text-left">Content</th>
                                    <th className="px-4 py-2 text-left">Status</th>
                                    <th className="px-4 py-2 text-left">Date</th>
                                    <th className="px-4 py-2 text-left">Replies</th>
                                </tr>
                            </thead>
                            <tbody>
                                {comments.map((comment) => (
                                    <tr key={comment._id} className="border-b hover:bg-gray-100">
                                        <td className="px-4 py-2">
                                           <Trash 
                                           onClick={()=>deleteCommentOrReply(comment._id, "")}
                                           className='cursor-pointer text-red-500'/>
                                           {/* <Edit className='mt-2 cursor-pointer text-indigo-500'/> */}
                                        </td>
                                        <td className="px-4 py-2">
                                            <strong>{comment.userId.name}</strong>
                                            <br />
                                            <span className="text-sm text-gray-600">{comment.userId.email}</span>
                                        </td>
                                        <td className="px-4 py-2">{comment.content}</td>
                                        <td className="px-4 py-2">
                                            {comment.status !== "Approved" ? (
                                                <button className='p-1 rounded-xl border cursor-pointer border-indigo-400'
                                                    onClick={() => approveCommentOrReply(comment?._id, "")}
                                                >{approveLoading ? "Approving..." : "Approve"}</button>
                                            ) : (
                                                comment.status
                                            )}
                                        </td>
                                        <td className="px-4 py-2">{new Date(comment.createdAt).toLocaleString()}</td>
                                        <td className="px-4 py-2 text-center text-indigo-600 cursor-pointer"
                                            onClick={() => setViewReplies({ state: true, replies: comment.replies, commentId: comment._id })}
                                        >
                                            {comment.replies.length}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
            }

            <CustomOffCanvas
                open={viewreplies?.state && viewreplies?.replies?.length > 0}
                close={() => { setViewReplies({ state: false, lessonId: "" }) }}
                content={
                    <Replies
                        close={() => { setViewReplies({ state: false, lessonId: "",commentId:"" }) }}
                        replies={viewreplies?.replies}
                        commentId={viewreplies?.commentId}
                        ApproveReply={approveCommentOrReply}
                        deleteReply={deleteCommentOrReply}
                    />
                }
            />
        </div>
    );
};

export default CommentTable;